<template>
  <div>
    <div v-if="!viewData">
      <div class="box w-full mb-2">
        <div class="p-2">
          <div class="h-10 rounded-sm bg-gray-300 animate-pulse mb-4"><span class="hidden">{{ n }}</span></div>
          <div v-for="n in 4" :key="n" class="grid grid-cols-4 gap-4">
            <div class="col-span-1 h-4 rounded-sm bg-gray-300 animate-pulse my-2"></div>
            <div class="col-span-1 h-4 rounded-sm bg-gray-300 animate-pulse my-2"></div>
            <div class="col-span-1 h-4 rounded-sm bg-gray-300 animate-pulse my-2"></div>
            <div class="col-span-1 h-4 rounded-sm bg-gray-300 animate-pulse my-2"></div>
          </div>
        </div>
      </div>
    </div>

    <div v-else>
      <div v-if="stageDetails.length > 0">
        <DataTable
          :value="stageDetails"
          responsiveLayout="stack"
          breakpoint="960px"
          class="p-datatable-sm text-sm"
          showGridlines
        >
          <template #header>
            Detalle Fase
          </template>
          <Column field="acctcode" header="Cuenta"></Column>
          <Column field="lieneaDeGasto" header="Línea de Gasto"></Column>
          <Column field="subTotal" header="Debito" style="text-align: right">
            <template #body="slotProps">
              <span>{{ $h.formatCurrency(slotProps.data.subTotal, 1) }}</span>
            </template>
          </Column>
          <Column field="iva" header="Credito" style="text-align: right">
            <template #body="slotProps">
              <span>{{ $h.formatCurrency(slotProps.data.credito, 1) }}</span>
            </template>
          </Column>
          <Column field="total" header="Valor Total" style="text-align: right">
            <template #body="slotProps">
              <span>{{ $h.formatCurrency(slotProps.data.total, 1) }}</span>
            </template>
          </Column>
          <!-- <Column field="actions" header="Acciones">
            <template>
              <a
                class="no-underline hover:underline text-indigo-600 cursor-pointer font-bold"
              >
                Detalle
              </a>
            </template>
          </Column> -->
        </DataTable>
      </div>

      <div v-else class="flex flex-col justify-center items-center">
        <h3 class="text-red-400 font-medium text-lg text-center">No hay información </h3>
        <img class="opacity-50 w-40 h-40" src="data:image/svg+xml;base64,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"  alt="Sin informacion"/>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from 'vue'
import listStageDetails from '../../../../../services/listStageDetails'
import { useToast } from 'primevue/usetoast'

export default {
  name: 'stageDetails',
  props: {
    numberStage: {
      type: String,
      default: null
    }
  },
  setup (props, context) {
    const toast = useToast()
    const viewData = ref(true)
    const stageDetails = ref({})

    /* */
    const fetchStageDetails = () => {
      return listStageDetails({ id: `${props.numberStage}` }).then(({ status, data: response }) => {
        console.log('Response: ', response)
        if (status !== 200) {
          toast.add({ severity: 'error', summary: 'Error', detail: 'Problemas al listar el detalle de la fase, consulte con el administrador del sistema', life: 3000 })
        } else {
          if (response.length > 0) {
            stageDetails.value = response
            viewData.value = true
          }
        }
      }).catch(err => {
        toast.add({ severity: 'error', summary: 'Error', detail: 'Problemas al listar el detalle de la fase, consulte con el administrador del sistema', life: 3000 })
        viewData.value = true
        console.error(err.message)
      })
    }

    onMounted(() => {
      fetchStageDetails()
    })

    return {
      viewData,
      stageDetails
    }
  }
}
</script>

<style scoped>

</style>
